import React from "react";
import ICONS from "src/assets/icons";
import { CardSolution } from "src/components/cards/CardSolution";
// import orange from "src/assets/images/orange.png";
// import bceao from "src/assets/images/bceao.png";
// import forvismazars from "src/assets/images/forvismazars.png";
// import myriadconnect from "src/assets/images/myriadconnect.png";
// import cloudoor from "src/assets/images/cloudoor.jpg";

const features = [
  {
    title: "Un cloud souverain",
    descriptions: [
      "Un Cloud moderne local (par pays) et régional (UEMOA)",
      "Une infrastructure souveraine pour sécuriser les données sensibles",
    ],
    icon: ICONS.Cloud(),
  },
  {
    title: "Jusqu’à 80% d’économies",
    descriptions: [
      "Startups et PME : Des offres attractives dès 100 000 XOF",
    "Grandes entreprises : économisez jusqu’à 80 % avec des plateformes modernes versus un cloud privé interne."],
    icon: ICONS.Wallet(),
  },
  {
    title: "Coûts exorbitants",
    descriptions: [
      "Environnements kubernetes à la demande avec pipelines DevOps intégrés",
      "Déploiement facile de tous types de workloads: IA, Base de données et code applicatif.",
    ],
    icon: ICONS.Cost(),
  },
];

const PartnersSection: React.FC = () => {
  return (
    <div className="mt-[3rem]">
      {/* <p className="font-bold text-center">TRUSTED PARTNERS:</p>
      <div className="flex items-center justify-center py-6 px-4">
        <div className="flex flex-wrap items-center justify-center bg-white rounded-full shadow-lg px-6 py-3 gap-4 sm:gap-6 lg:justify-between">
          <img src={cloudoor} alt="Cloudoor" className="h-8 sm:h-[5rem]" />
          <img src={orange} alt="Orange" className="h-8 sm:h-[5rem]" />
          <img src={bceao} alt="BCEAO" className="h-8 sm:h-[5rem]" />
          <img src={forvismazars} alt="Forvus Mazars" className="h-8 sm:h-[5rem]" />
          <img
            src={myriadconnect}
            alt="Myriad Connect"
            className="h-8 sm:h-[5rem]"
          />
        </div>
      </div> */}
      <div className="grid-background-image-top">
        <div className="flex items-center justify-center mt-[6rem] mx-auto text-center p-6">
          <h1 className="text-[32px] sm:text-[40px] md:text-[48px] font-[400] leading-[1.2]">
            Solutions technologiques créées <br /> pour les{" "}
            <i className="app-title-italic text-[#20E87F] text-[32px] sm:text-[40px] md:text-[48px] font-[400] leading-[1.2]">
              entreprises
            </i>
            &nbsp;de l'UEMOA
          </h1>
        </div>
        <section className="mt-[1rem] py-12 px-6">
          <div className="max-w-[85rem] mx-auto grid grid-cols-1 md:grid-cols-3 gap-6">
            {features.map((feature, index) => (
              <CardSolution
                descriptions={feature.descriptions}
                title={feature.title}
                key={index}
                icon={feature.icon}
              />
            ))}
          </div>
        </section>
      </div>
    </div>
  );
};

export default PartnersSection;
